<div class="alert alert-{{ type }}" role="alert" style="margin-bottom: 0;">
    {{ message }}
    <button type="button" class="close" data-dismiss="alert" aria-label="Close" (click)="onClose()">
        <span aria-hidden="true">&times;</span>
    </button>
</div>